import React, { FC, useState } from 'react';

import { PageTitle } from '../common-styles/common-styles';
import { Course } from '../../../database.schema';
import { CourseEntry } from './course-entry';
import * as CSS from './course-styles';
import { useFetchCourses } from '../../api/hooks/use-fetch-courses';

const pars = [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
const si = [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10];
const newCourse = { scoreCard: [...pars], strokeIndex: [...si], name: '', id: 0 };

export const CourseAdmin: FC = () => {
  const [addCourse, setAddCourse] = useState<boolean>(false);
  const [editCourse, setEditCourse] = useState<boolean>(false);
  const [editCourseData, setEditCourseData] = useState<Course | undefined>();
  const { data, error, isLoading } = useFetchCourses();

  if (isLoading) {
    return <div>loading</div>;
  }
  if (error) {
    return <div>Error</div>;
  }
  const courses = data as Course[];
  if (addCourse) {
    return <CourseEntry course={{ ...newCourse, id: courses.length + 1 }} courseIndex={courses.length} resetDataEntry={setAddCourse} />;
  }
  if (editCourse && editCourseData) {
    return <CourseEntry resetDataEntry={setEditCourse} courseIndex={editCourseData.id - 1} course={editCourseData} />;
  }
  return (
    <div>
      <PageTitle>
        <h2>Course Admin</h2>
      </PageTitle>
      <ul>
        {courses.map((course: Course) => (
          <CSS.CourseListItem key={`course-${course.id}`}>
            <div key={course.id}>{course.name}</div>
            <CSS.Button
              data-testid={course.name}
              onClick={() => {
                setEditCourseData(course);
                setEditCourse(true);
              }}
            >
              Edit
            </CSS.Button>
          </CSS.CourseListItem>
        ))}
      </ul>
      <CSS.Button data-testid="add-course" onClick={() => setAddCourse(true)}>
        Add
      </CSS.Button>
    </div>
  );
};
